import styled from 'styled-components';

import Box from '@spotnana/pixel-react/dist/Box';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';
import Typography from '@spotnana/pixel-react/dist/Typography';

// TODO: transform style here is used to have space between cards
// Please use grid and column-gap instead of transform.
export const CardBaseContainer = styled(Box)`
  display: block;
  padding: 24px;
  border-radius: ${spotnanaTheme.radii.sm}px;
  width: 220px;
  height: 146px;
  position: relative;
  transform: scale(0.95);
`;

export const CardTitle = styled(Typography)`
  font-size: ${spotnanaTheme.fontSizes.small};
  font-weight: ${spotnanaTheme.fontWeights.semiBold};
`;

export const CardDivider = styled(Box)`
  margin: 0 -24px;
  margin-bottom: 16px;
  /* stylelint-disable-next-line color-no-hex */
  background-color: #0055a1;
  height: 2px;
`;

export const CardText = styled(Typography)`
  font-size: ${spotnanaTheme.fontSizes.label};
  line-height: ${spotnanaTheme.lineHeights.value};
`;

export const CustomLogoContainer = styled(Box)`
  position: absolute;
  top: -16px;
  right: -16px;
`;
